import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class User extends BaseAPIModel {
    fields() {
        return {
            user_id: { primaryKey: true, readOnly: true },
            name: {}
        };
    }

    static fromJWT({ payload: { data } } = {}) {
        if (!data) {
            throw new Error('data key must be present in jwt');
        }

        return new this(data);
    }

    toString() {
        // a space if firstname and name are defined, empty string else
        const sep = ' '.repeat(Boolean(this.firstname && this.name));
        return `${this.firstname}${sep}${this.name}`;
    }

    getEmail() {
        return this.email || '';
    }
}
